import React, { Component } from "react";
import axios from "axios";
import Loader from "../../components/Loader/Loader";
import { Redirect } from "react-router-dom";
import Login from "../../components/Login/Login";
import {permissionPopupCheckOnLogin} from '../../functions/FCMToken';
import WebNotifPermission from '../../components/WebNotifPermisssion/WebNotifPermission';

class LoginBuilder extends Component {
  state = {
    loggedIn: false,
    layer:true,
    show_model_info_popup: false,
    model_info: null,
    show_notif_permission_popup: false,//permissionPopupCheckOnLogin(),
    login: {
      name: "",
      password: "",
      formValidity: false,
      redirectUrl: "/",
      failure: false,
      loader: false,
      failureMessage: "Please enter correct username and password"
    },
    signup: {
      display: false,
      showInitialView: true,
      category: "live",
      gstin: {
        value: "",
        error: "",
        disabled: false,
        no_gst: false,
      },
      gstToggle: {
        value: false,
        placeholder: "I do not have a GST number",
        disabled: false
      },
      reg_no: {
        value: "",
        error: "",
        disabled: false,
      },
      model: {
        value: "2",
        error: "",
        disabled: false,
      },
      otp: {
        value: "",
        error: "",
        showTimer: false,
        resend: false,
        timer: 5,
        disabled: true,
        show_disabled_otp: false,
      },
      verify_gst_data: null,
      templates: null,
      continueBtnLoading: false, 
      continueSignUpLoading: false,
      agreements_txt: null,
    },
  };

  showSignUpPage = () => {
    this.setState({signup: {...this.state.signup, display: true}});
  }

  togglePermissionPopup = () => {
    this.setState((prevState) => ({
      show_notif_permission_popup: !prevState.show_notif_permission_popup,
    }), () => {
      if(window.SellerFirebaseAnalytics && window.SellerFirebaseAnalytics.logEvent) {
        window.SellerFirebaseAnalytics.logEvent('permission_popup_close', {});
      }
    })
  }

  changeEventHandler = (e,type) => {
    if(!!e && !!type) {
      if(type === "login") {
        const nextState = { ...this.state };
        const nextStateLogin = { ...nextState.login };
        nextStateLogin[e.target.id] = e.target.value.replace(/\s/g, "");
        nextStateLogin.formValidity = !!nextStateLogin.name.length && !!nextStateLogin.password.length;
        this.setState({
          login: nextStateLogin
        });
      } else if (type === "signup") {
        let signup = {...this.state.signup};
        if(e.target.id !== "otp") {
          signup.otp.resend = false;
          signup.otp.showTimer = false;
        }
        if(e.target.id === "otp") {
          if(/^[0-9]+$/.test(e.target.value) || e.target.value === "") {
            signup[e.target.id].value = e.target.value;
          }
        } else if (e.target.id === "reg_no") {
          if(/^[0-9]+$/.test(e.target.value) || e.target.value === "") {
            signup[e.target.id].value = e.target.value;
          }
          signup.reg_no.error = "";
          if(!/^[6-9]\d{9}$/.test(e.target.value)) {
            signup.reg_no.error = "Enter valid 10 digit mobile number";
          }
        } else if (e.target.id === "gst_toggle") {
          signup.gstToggle.value = !signup.gstToggle.value
          // signup.gstin.value = "";
          if(signup.gstToggle.value) {
            signup.gstin.no_gst = true;
          } else {
            signup.gstin.no_gst = false;
          }
        } else if (e.target.id === "gstin") {
          signup.gstin.value = e.target.value.toUpperCase();
        } else {
          signup[e.target.id].value = e.target.value;
        }
        this.setState({signup});
      } else {
        return;
      }
    }
  };

  getOtp = () => {
    // check for errors
    if(this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }

    let signup = {...this.state.signup};
    // regex check on gstin
    signup.gstin.error = "";
    signup.reg_no.error = "";
    signup.model.error = "";
    signup.otp.value = "";
    signup.otp.error = "";
    signup.otp.resend = false;
    signup.otp.showTimer = false;
    signup.otp.timer = 59;

    let error = false;
    if(signup && signup.gstin && signup.gstToggle.value !== true && !/\d{2}[A-Za-z]{5}\d{4}[A-Za-z]{1}[A-Za-z\d]{1}[Zz]{1}[A-Za-z\d]{1}/.test(signup.gstin.value)) {
      signup.gstin.error = "Enter Valid GST";
      error = true;
    }
    if(signup && signup.reg_no && (!/^[0-9]+$/.test(signup.reg_no.value) || signup.reg_no.value.length !== 10)) {
      signup.reg_no.error = "Enter Valid registered mobile number";
      error = true;
    }
    if(signup && signup.model && signup.model.value === "") {
      signup.model.error = "Select a model";
      error = true;
    }
    if(error) {
      this.setState({signup});
      return;
    }

    signup.continueBtnLoading = true;
    this.setState({signup});

    // check if GSTIN exists in our records and prefill if it does
    axios.get("/seller_portal/verify_gst_details", {
      params: {
        gstin: signup.gstin.value ? signup.gstin.value : "NA",
        mobile_no: signup.reg_no.value,
        model: signup.model.value,
      }
    })
    .then(response => {
      response = response && response.data;
      console.log(response);
      let signup = {...this.state.signup};
      // get otp call here
      // console.log("OTP sent");
      signup.model.disabled = true;
      signup.gstin.disabled = true;
      signup.gstToggle.disabled = true;
      signup.reg_no.disabled = true;
      signup.otp.disabled = false;
      signup.otp.show_disabled_otp = true;
      signup.verify_gst_data = !!response.gst_details && JSON.parse(response.gst_details);
      signup.templates = response.templates;
      signup.continueBtnLoading = false;
      signup.agreements_txt = !!response.gst_details && !!JSON.parse(response.gst_details).user_agreement ? JSON.parse(response.gst_details).user_agreement : [];

      this.setState({signup}, this.otpAxiosCall);

      if(window.SellerFirebaseAnalytics && window.SellerFirebaseAnalytics.logEvent){
				var logData = {
          gstin: signup.gstin.value,
          mobile_no: signup.reg_no.value,
          model: signup.model.value,
          category: signup.category
        }
				if(this.props && this.props.location && this.props.location.pathname){
					logData["pathname"] = this.props.location.pathname;
				}
				window.SellerFirebaseAnalytics.logEvent("onboarding_count",logData);
			}
    })
    .catch(error => {
      console.log(error);
      let signup = {...this.state.signup};
      // get otp call here
      // console.log("OTP sent");
      signup.reg_no.error = (error && error.response && error.response.data && error.response.data.error_msgs) ? error.response.data.error_msgs : "Failed to fetch GSTIN details, please retry";
      signup.continueBtnLoading = false;

      this.setState({signup});

      if(window.SellerFirebaseAnalytics && window.SellerFirebaseAnalytics.logEvent){
				var logData = {
          gstin: signup.gstin.value,
          mobile_no: signup.reg_no.value,
          model: signup.model.value,
          category: signup.category,
          error: true,
          error_msgs: "verify_gst_details api error"
        }
				if(this.props && this.props.location && this.props.location.pathname){
					logData["pathname"] = this.props.location.pathname;
				}
				window.SellerFirebaseAnalytics.logEvent("onboarding_count",logData);
			}
    })
    
  }

  otpAxiosCall = () => {
    axios.get("/seller_portal/send_otp", {
      params: {
        gstin: this.state.signup.gstin.value ? this.state.signup.gstin.value : "NA",
        mobile_no: this.state.signup.reg_no.value,
      }
    })
    .then(response => {
      response = response && response.data;
      let signup = {...this.state.signup};
      signup.otp.show_disabled_otp = false;
      signup.otp.resend = false;
      signup.otp.timer = 59;
      signup.otp.showTimer = true;
      this.setState({signup}, this.OTPtimer);
    })
    .catch(error => {
      let signup = {...this.state.signup};
      signup.otp.error = "Failed to send OTP to number";
      signup.otp.show_disabled_otp = true;
      if(error && error.response && error.response.data && error.response.data.error_msgs) {
        signup.otp.error = error.response.data.error_msgs;
      }
      this.setState({signup});
    })
  }

  resendOTPaxiosCall = () => {
    axios.get("/seller_portal/resend_otp", {
      params: {
        mobile_no: this.state.signup.reg_no.value,
      }
    })
    .then(response => {
      response = response && response.data;
      let signup = {...this.state.signup};
      signup.otp.showTimer = true;
      signup.otp.resend = false;
      signup.otp.error = "";
      signup.otp.timer = 59;
      this.setState({signup}, this.OTPtimer);
    })
    .catch(error => {
      let signup = {...this.state.signup};
      signup.otp.showTimer = false;
      signup.otp.resend = true;
      signup.otp.error = "Failed to resend OTP to number, please retry";
      signup.otp.timer = 59;
      this.setState({signup});
    })
  }

  verifyOtpAxiosCall = () => {
    axios.get("/seller_portal/verify_otp", {
      params: {
        otp: this.state.signup.otp.value,
        mobile_no: this.state.signup.reg_no.value,
      }
    })
    .then(response => {
      response = response && response.data;
      let signup = {...this.state.signup};
      this.props.history.push({
        pathname: "/newsell/onboarding",
        state: {
          model: signup.model.value,
          gstin: signup.gstin.value,
          reg_no: signup.reg_no.value,
          verify_gst_data: signup.verify_gst_data,
          agreements_txt: signup.agreements_txt,
          templates: signup.templates
        }
      })
    })
    .catch(error => {
      let signup = {...this.state.signup};
      signup.otp.error = "Entered OTP does not match. Check your mobile number or resend OTP";
      signup.otp.showTimer = false;
      signup.otp.resend = true;
      signup.otp.timer = 59;
      signup.continueSignUpLoading = false;
      this.setState({signup});
    })
  }

  OTPtimer = () => {
    let timer = setInterval(() => {
      this.setState((prevState) => ({
        signup: {
          ...prevState.signup,
          otp: {
            ...prevState.signup.otp,
            timer: prevState.signup.otp.timer - 1,
          }
        }
      }), () => {
        if(this.state.signup.otp.timer <= 0) {
          let signup = {...this.state.signup};
          signup.otp.timer = 59;
          signup.otp.showTimer = false;
          signup.otp.resend = true;
          this.setState({signup}, () => clearInterval(timer));
        }
      })
    }, 1000);
    this.timer = timer;
  }

  changeRegNo = () => {
    if(this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }

    let signup = {...this.state.signup};

    // cancel OTP req if any

    signup.model.disabled = false;
    if(signup.gstin.value === "") {
      signup.gstin.no_gst = true;
      signup.gstToggle.value = true;
    } else {
      signup.gstin.no_gst = false;
      signup.gstToggle.value = false;
    }
    signup.gstin.disabled = false;
    signup.gstToggle.disabled = false;
    signup.reg_no.disabled = false;
    signup.otp.value = "";
    signup.otp.error = "";
    signup.otp.showTimer = false;
    signup.otp.resend = false;
    signup.otp.timer = 59;
    signup.otp.disabled = true;
    if(signup.model.value === "0") {
      signup.gstToggle.disabled = true;
    }

    this.setState({signup});
  }

  submitGstin = () => {
    let signup = {...this.state.signup};

    // if(signup && signup.gstin && signup.reg_no) {
    //   if( signup.gstin.value === "" || signup.reg_no.value === "" || signup.gstin.value.length !== 15 || signup.reg_no.value.length !== 10) {
    //     this.getOtp();
    //     signup.otp.error = "Fill above values before proceeding";
    //     this.setState({signup});
    //     return;
    //   }
    // }
    
    if(signup && signup.otp && signup.otp.value.length < 4) {
      signup.otp.error = "Enter 4 digit OTP to proceed";
      this.setState({signup});
      return;
    }

    if(this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }

    signup.otp.error = "";
    signup.otp.showTimer = false;
    signup.otp.resend = false;
    signup.otp.timer = 59;
    signup.continueSignUpLoading = true;

    this.setState({signup}, this.verifyOtpAxiosCall);

    // if(validOtp) {
    //   this.props.history.push({
    //     pathname: "/newsell/onboarding",
    //     state: {
    //       model: signup.model.value,
    //       gstin: signup.gstin.value,
    //       reg_no: signup.reg_no.value,
    //       verify_gst_data: signup.verify_gst_data,
    //     }
    //   })
    // } else {
    //   signup.otp.error = "Entered OTP does not match. Check your mobile number or resend OTP";
    //   signup.otp.showTimer = false;
    //   signup.otp.resend = true;
    //   signup.otp.timer = 59;
    //   this.setState({signup});
    // }
  }

  // remove this later
  dummyOtpChecker = () => {
    let signup = {...this.state.signup};
    if(signup.otp.value === "1234") {
      return true;
    } else {
      return false;
    }
  }

  submitHandler = (e) => {
    e.preventDefault();
    const {redirectUrl} = this.state;
    let newLoginState = {...this.state.login};
    newLoginState.loader = true;

    this.setState({
      login: newLoginState
    });
    if (this.state.login.formValidity) {
      axios.post('/home/login', {
        name: this.state.login.name,
        password: this.state.login.password,
        react: true
      }).then((response)=>{
        newLoginState.loader = false;
        newLoginState.failure = false;
        // this.props.history.push(redirectUrl);
        window.location = redirectUrl;
      }).catch((error) =>{
        newLoginState.loader = false;
        newLoginState.failure = true;
        this.setState({
          login: newLoginState
        })
      });
      // this.props.history.push("/newsell/test2");
    } else {
      alert("Please enter login credentials");
    }
  };

  signUpCategorySelector = (cat) => {
    let signup = {...this.state.signup};
    signup.showInitialView = false;
    if(cat === "core") {
      signup.model.value = "0"; // change to a new value for core sellers
      signup.category = "core";
      signup.gstToggle.disabled = true;
    }
    this.setState({signup});
  }

  // validateEmailUsername = (name) => {
  //   if (
  //     /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(name) ||
  //     /^lr_[a-zA-Z0-9]+$/.test(name) ||
  //     name==="Aviral") return true;
  //   return true;
  // };
  
  componentDidMount(){

    // uncomment this before deployment if commented and remove last line 

    const { location } = this.props;
    location && location.pathname && (this.setState({redirectUrl: `${location.pathname}${location.search}`}));
    axios.get('/home/check_logged_in_user')
      .then((response)=>{
        this.setState({loggedIn:true,layer:false}, this.fetchModelDetails);
      }).catch((error) =>{
        this.setState({loggedIn:false,layer:false}, this.fetchModelDetails)
    });
    //this.setState({loggedIn:false,layer:false})
  }

  fetchModelDetails = () => {
    axios.get('/seller_portal/fetch_model_details')
    .then((response) => {
      if(response && response.data) {
        this.setState({model_info: response.data});
      }
    }).catch((error) => {
      console.log(error);
    })
  }
  
  toggleModelInfoPopup = () => {
    this.setState((prevState) => ({
      show_model_info_popup: !prevState.show_model_info_popup,
    }));
  }

  render() {
    const {login,loggedIn,layer,signup, model_info, show_model_info_popup,show_notif_permission_popup} = this.state;
    return (
      <React.Fragment>
        {layer ? (
            <Loader/>
        ) :
        (
          <React.Fragment>
            {(loggedIn) ? (
              <Redirect to="/newsell/home/select_vendor" />
            ) : (
              <React.Fragment>
                {(false) ? <WebNotifPermission togglePopup={this.togglePermissionPopup}/> : null}
                <Login 
                  login={login} 
                  changeEventHandler={this.changeEventHandler} 
                  submitHandler={this.submitHandler} 
                  signup={signup} 
                  showSignUpPage={this.showSignUpPage}
                  getOtp={this.getOtp}
                  changeRegNo={this.changeRegNo}
                  submitGstin={this.submitGstin}
                  resendOTPaxiosCall={this.resendOTPaxiosCall}
                  show_model_info_popup={show_model_info_popup}
                  model_info={model_info}
                  toggleModelInfoPopup={this.toggleModelInfoPopup}
                  categorySelector={this.signUpCategorySelector}
                />
              </React.Fragment>
            )}
          </React.Fragment>
        )}
      </React.Fragment>
      

    );
  }
}

export default LoginBuilder;
